// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1k985","clinicsSelect":"TableHeading_clinicsSelect__2cshT"};